<template>
  <div class="page">
    <!-- 新闻资讯 -->
    <div class="nav_top"></div>
    <navigation-bar2 />
    <div class="swiperModel">
      <div v-for="(item, index) in lunboImgs" :key="index">
        <img :src="imgUrl + item.img" alt="" />
      </div>
    </div>
    <div class="options">
      <div class="text" @click="clickOption(1)">宝成动态</div>
      <div class="text" @click="clickOption(2)">行业资讯</div>
    </div>
    <div class="newsList">
      <div class="newsItem" v-for="(item, index) in newsCenter" :key="index + '1'">
        <div class="left">
          <p class="title">{{ item.title }}</p>
          <p class="time">
            <img :src="imgUrl + item.timeImg" alt="" /><span>{{ item.date }}</span>
          </p>
          <p class="text content">
            {{ item.content }}
          </p>
          <p class="btn" @click="viewDetail(item)">查看详情＞＞</p>
        </div>
        <div class="right"><img :src="imgUrl + item.homePageImg" alt="" /></div>
      </div>
    </div>
    <div class="pagination">
      <p class="btn">首页</p>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <p class="btn">末页</p>
    </div>
    <bottom-area />
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      imgUrl: this.$store.state.imgUrl,
      type: 1,
      lunboImgs: [],
      newsCenter: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() {
    this.getData();
  },
  components: {
    NavigationBar2: () => import("../views/nav/NavigationBar2"),
    SwiperPage2: () => import("../views/swiper/SwiperPage2"),
    serchProduct: () => import("../views/searchProduct/serchProduct"),
    BrandProducts: () => import("../views/BrandProducts/BrandProducts"),
    ProductList: () => import("../views/ProductList/ProductList"),
    BottomArea: () => import("../views/footer/BottomArea"),
  },
  methods: {
    async getData() {
      const { data: res } = await this.$http.get("/newsCenter/list", {
        params: {
          type: this.type,
          page: this.currentPage,
          limit: this.pageSize,
        },
      });
      if (res.code == 200) {
        console.log(res);
        this.lunboImgs = res.result.lunboImgs;
        this.newsCenter = res.result.newsCenter;
        this.total = res.result.total;
      }
    },
    viewDetail(item) {
      this.$router.push({
        path: "/newsDetails",
        query: {
          id: item.id,
        },
      });
    },
    clickOption(type) {
      this.type = type;
      this.currentPage = 1;
      this.pageSize = 10;
      this.getData();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
.swiperModel {
  width: 100%;
  height: 680px;
}
.nav_top {
  width: 100%;
  height: 15px;
  background-color: #19344a;
  color: #ffffff;
}
.options {
  width: 100%;
  height: 150px;
  line-height: 150px;
  background-color: #f0f1f3;
  display: flex;
  justify-content: space-between;
  .text:nth-child(1) {
    font-size: 26px;
    letter-spacing: 3px;
    text-align: right;
    width: 50%;
    padding-right: 100px;
  }
  .text:nth-child(2) {
    font-size: 26px;
    letter-spacing: 3px;
    text-align: left;
    width: 50%;
    padding-left: 100px;
  }
}
.newsList {
  width: 100%;
  padding: 30px 150px;
  box-sizing: border-box;
  .newsItem {
    width: 100%;
    height: 400px;
    box-sizing: border-box;
    display: flex;
    background-color: #f0f1f3;
    position: relative;
    margin-bottom: 30px;
    overflow: hidden;
    box-sizing: border-box;
    .left {
      width: 1170px;
      padding: 20px 50px;
      .title {
        font-size: 26px;
        color: #49bbb9;
        font-weight: 700;
        letter-spacing: 4px;
        margin-bottom: 30px;
        margin-top: 10px;
      }
      .time {
        margin-bottom: 30px;
        img {
          width: 25px;
          vertical-align: middle;
          margin-right: 15px;
        }
        span {
          vertical-align: middle;
          color: #787878;
        }
      }
      .text {
        font-size: 15px;
        color: #666666;
        letter-spacing: 5px;
        line-height: 1.5em;
        text-indent: 2em;
        // text-align-last: justify;
      }
      .btn {
        width: 180px;
        border: 2px solid #787878;
        text-align: center;
        padding: 3px 0;
        color: #787878;
        letter-spacing: 3px;
        cursor: pointer;
        position: absolute;
        bottom: 60px;
        left: 50px;
      }
    }
    .right {
      width: 450px !important;
      img {
        width: 450px;
        height: auto;
        margin-top: 50px;
      }
    }
  }
}
.pagination {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  .btn {
    width: 50px;
    height: 32px;
    line-height: 32px;
    background-color: #f4f4f5;
    cursor: pointer;
  }
}
</style>
